import { render, staticRenderFns } from "./CompanyChangeLogsDetailsView.vue?vue&type=template&id=4e378674&scoped=true"
import script from "./CompanyChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./CompanyChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./CompanyChangeLogsDetailsView.vue?vue&type=style&index=0&id=4e378674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e378674",
  null
  
)

export default component.exports